import {CloudIcon} from '@primer/octicons-react'
import type {EnvironmentStatus} from '@github-ui/agent-sessions-types/environment'

/** UI grouping for a picker option (not the MC `EnvironmentKind`): `cloud` is
 * the Actions option, while the managed Cloud option keeps the internal
 * `sandbox` kind and shares the relay path with `ahp`. */
export type EnvironmentKind = 'cloud' | 'sandbox' | 'ahp'

export const CLOUD_ENVIRONMENT_ID = 'background-agent'

/** Static Mission Control environment id sentinel that provisions a
 * GitHub-managed sandbox VM on demand instead of binding to an existing one. */
export const SANDBOX_ENVIRONMENT_ID = 'github-sandbox'

export type EnvironmentOption = {
  id: string
  kind: EnvironmentKind
  label: string
  icon: React.ComponentType<{size?: number | 'small' | 'medium' | 'large'}>
  /** Mission Control environment id to bind to: a real id for `ahp`, the
   * `github-sandbox` sentinel for `sandbox`. Unused for `cloud`. */
  environmentId?: string
  /** For `ahp` options: the environment's operational status. */
  status?: EnvironmentStatus
  /** For `ahp` options: whether the environment's advertised `ahp_version` is one
   * this client can negotiate. `false` disables the option even when online. */
  versionSupported?: boolean
  /** Whether the option can be selected. Non-`online` AHP environments are
   * listed but not selectable, since only `online` environments accept new
   * sessions. */
  disabled?: boolean
}

export const CLOUD_ENVIRONMENT_OPTION: EnvironmentOption = {
  id: CLOUD_ENVIRONMENT_ID,
  kind: 'cloud',
  label: 'Actions',
  icon: CloudIcon,
}

export const SANDBOX_ENVIRONMENT_OPTION: EnvironmentOption = {
  id: SANDBOX_ENVIRONMENT_ID,
  kind: 'sandbox',
  label: 'Cloud',
  icon: CloudIcon,
  environmentId: SANDBOX_ENVIRONMENT_ID,
}
